import Loadable from '../../components/loadable';

const ManageExerciseDrawer = Loadable({
  loader: () => import('react/pages/workouts/manage_exercise_drawer'),
  type: 'drawer',
});

angular.module('gym').value('ManageExerciseDrawer', ManageExerciseDrawer);
